import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FooterBarComponent } from '../footer-bar/footer-bar.component';
import { HeaderBarComponent } from '../header-bar/header-bar.component';
import { MainMenuComponent } from '../main-menu/main-menu.component';
import { SaldoGoiComponent } from '../saldo-goi/saldo-goi.component';
import { ButtonsModule } from '../../common-elements/buttons/buttons-module/buttons.module';
import { PopOptionsListComponent } from '../pop-options-list/pop-options-list.component';
import { BuildMessageComponent } from '../build-message/build-message.component';
import { SinResultadosComponent } from '../sin-resultados/sin-resultados.component';
import { ConfiguracionComponent } from '../configuracion/configuracion.component';
import { CuentaComponent } from '../cuenta/cuenta.component';
import { InformacionDelUsuarioComponent } from '../informacion-del-usuario/informacion-del-usuario.component';
import { PrivacidadComponent } from '../privacidad/privacidad.component';
import { SeguridadComponent } from '../seguridad/seguridad.component';
import { VerificacionDeCuentaComponent } from '../verificacion-de-cuenta/verificacion-de-cuenta.component';
import { PasswordComponent } from '../password/password.component';
import { SliderComponent } from '../../publication/single-elements/slider/slider.component';
import { RegaloModalComponent } from '../Regalo-Modal/Regalo-Modal.component';
import { FilterBarComponent } from '../Filter-Bar/Filter-Bar.component';
import { PublicacionesColeccionComponent } from '../../publication/create/publicaciones-coleccion/publicaciones-coleccion/publicaciones-coleccion.component';
import { FormsModule } from '@angular/forms';
//import { WalletAppComponent } from 'src/app/components/go-ecosystem/wallet-app/wallet-app.component';
import {AIPopupComponentComponent} from 'src/app/ai-popup-component/ai-popup-component.component';
import {TpPostComponent} from 'src/app/tp-post/tp-post.component';
import {MyObservationsComponent} from 'src/app/my-observations/my-observations.component';
import{ContentPreferencesComponent}from'src/app/content-preferences/content-preferences.component';
import {StatsComponent} from 'src/app/stats/stats.component';
import {PlaylistsComponent} from 'src/app/playlists/playlists.component';
import {StockKeepingUnitSelectionComponent} from 'src/app/stock-keeping-unit-selection/stock-keeping-unit-selection.component';
import {AlibabaCheckoutCartComponent}  from 'src/app/alibaba-checkout-cart/alibaba-checkout-cart.component';
import { SortProdcutsOptionsPopoverComponent } from 'src/app/sort-prodcuts-options-popover/sort-prodcuts-options-popover.component';
import {SuperlativeStreamsComponent} from 'src/app/superlative-streams/superlative-streams.component';
import {MyDsPurchasesComponent} from 'src/app/my-ds-purchases/my-ds-purchases.component';
import {LkMusicViewComponent} from 'src/app/lk-music-view/lk-music-view.component';
import { LkfilmStudiosComponent} from 'src/app/lkfilm-studios/lkfilm-studios.component';
import { InlineBowsingComponent } from 'src/app/inline-bowsing/inline-bowsing.component';
import { AgentAccessesModalComponent } from '../../agent-accesses/agent-accesses-modal.component';
import { BienesModuleModule } from '../../publication/create/principal-components/bienes-module/bienes-module.module';
import { ShazamPageComponent } from 'src/app/shazam-page/shazam-page.component';
import { WeatherContextModule } from '../../common-elements/weather-context/weather-context.module';

@NgModule({
    declarations: [
        AgentAccessesModalComponent,
        InlineBowsingComponent,
        LkfilmStudiosComponent,
        ShazamPageComponent,
        LkMusicViewComponent,
        MyDsPurchasesComponent,
        SuperlativeStreamsComponent,
        SortProdcutsOptionsPopoverComponent,
        AlibabaCheckoutCartComponent,
        StockKeepingUnitSelectionComponent,
        PlaylistsComponent,
        StatsComponent,
        ContentPreferencesComponent,
        AIPopupComponentComponent,
        MyObservationsComponent,
        TpPostComponent,
        //WalletAppComponent,
        BuildMessageComponent,
        //ReturnBarComponent,
        FooterBarComponent,
        HeaderBarComponent,
        MainMenuComponent,
        SaldoGoiComponent,
        PopOptionsListComponent,
        SinResultadosComponent,
        ConfiguracionComponent,
        CuentaComponent,
        InformacionDelUsuarioComponent,
        PrivacidadComponent,
        SeguridadComponent,
        VerificacionDeCuentaComponent,
        PasswordComponent,
        RegaloModalComponent,
        FilterBarComponent
        //LoadingComponentComponent
    ],
    exports: [
        AgentAccessesModalComponent,
        InlineBowsingComponent,
        LkfilmStudiosComponent,
        ShazamPageComponent,
        LkMusicViewComponent,
        MyDsPurchasesComponent,
        SuperlativeStreamsComponent,
        SortProdcutsOptionsPopoverComponent,
        AlibabaCheckoutCartComponent,
        StockKeepingUnitSelectionComponent,
        PlaylistsComponent,
        StatsComponent,
        ContentPreferencesComponent,
        AIPopupComponentComponent,
        MyObservationsComponent,
        TpPostComponent,
        //WalletAppComponent,
        BuildMessageComponent,
        FooterBarComponent,
        HeaderBarComponent,
        MainMenuComponent,
        SaldoGoiComponent,
        PopOptionsListComponent,
        SinResultadosComponent,
        ConfiguracionComponent,
        CuentaComponent,
        InformacionDelUsuarioComponent,
        PrivacidadComponent,
        SeguridadComponent,
        VerificacionDeCuentaComponent,
        PasswordComponent,
        RegaloModalComponent,
        WeatherContextModule
        //LoadingComponentComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        ButtonsModule,
        FormsModule,
        BienesModuleModule,
        WeatherContextModule
    ]
})
export class GeneralModuleModule { }
